export default __webpack_public_path__ + "static/media/background.b3f54558.jpg";